// @ts-nocheck
const eventBus = {
  callbackf: null, //makes so that on & remove has same func reference
  on(event, callback) {
    this.callbackf = (e) => callback(e.detail)
    document.addEventListener(event, this.callbackf);
  },
  dispatch(event, data) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  },
  remove(event, callback) {
    document.removeEventListener(event, this.callbackf);
  },
};

export default eventBus;